import React from 'react';

import { Fecha } from 'src/componentes';
import TarjetaObservacion from './TarjetaObservacion';
import { TarjetaPropsComunes } from './tipos';

interface Props extends TarjetaPropsComunes {}

const TarjetaRetiro: React.FunctionComponent<Props> = props => {
    const { fechaAdicional, ...resto } = props;

    return (
        <TarjetaObservacion
            {...resto}
            elevado
            titulo='Retiro'
            mensajeExtra={
                fechaAdicional && (
                    <>
                        Se retiró el <Fecha fecha={fechaAdicional} />
                    </>
                )
            }
        />
    );
};

export default TarjetaRetiro;



// WEBPACK FOOTER //
// ./src/modulos/Cobranzas/componentes/FichaDeApoderado/Observaciones/TarjetaRetiro.tsx